import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  root: {
    width: '100%',
  },
  titleField: {
    width: '100%',
  },
  descField: {
    width: '100%',
  },
  addIconContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  addIcon: {
    width: '35px',
    height: '20px',
  },
  accordionRoot: {
    margin: '10px 0 !important',
    '&::before': {
      backgroundColor: 'unset',
    },
  },
  accordionExpanded: {
    margin: '10px 0 !important',
    '&:first-of-type': {
      marginTop: '0 !important',
    },
  },
  error: {
    fontSize: '12px',
    color: theme.palette.primary.error,
    borderColor: theme.palette.primary.error,
  },
  deleteIcon: {
    width: '35px',
    height: '20px',
    float: 'right',
    backgroundColor: '#f44336',
    '&:hover': {
      backgroundColor: '#d32f2f',
    },
  },
  noDetailsText: {
    fontSize: '14px',
    color: theme.palette.primary.sideBarTextColor,
    opacity: 0.7,
    fontStyle: 'italic',
    marginTop: '4px',
  },
  summaryContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  imageSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  buttonGroup: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  uploadButton: {
    textTransform: 'none',
    flex: 1,
    minWidth: '140px',
  },
  templateButton: {
    textTransform: 'none',
    flex: 1,
    minWidth: '140px',
  },
  previewContainer: {
    width: '100%',
    borderRadius: '8px',
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
    position: 'relative',
  },
  previewImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
    maxHeight: '200px',
    objectFit: 'contain',
  },
  deleteImageButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
    zIndex: 1,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
  },
};
